import React from 'react';
import {TreeSelect} from 'antd';
import commonExtendsHOC from '../../commonExtendsHOC';

export default commonExtendsHOC(TreeSelect);